import React, { JSX, useContext, useEffect, useMemo, useState } from "react";

import { Button } from "react-bootstrap";

import { propTypes } from "react-bootstrap/esm/Image";
import { useTranslation } from "react-i18next";

export function useTrialRedirect(): [
  (hint: boolean, config?: any, loginWithRedirect?: any, trialTag?: string) => Promise<void>,
  (props: { hint: boolean; config: any; loginWithRedirect: any; trialTag?: string }) => JSX.Element,
] {
  const { t, i18n } = useTranslation();
  //const { loginWithRedirect } = useAuth0();
  const RedirectForTrial = async (hint: boolean, config?: any, loginWithRedirect1?: any, trialTag?: string) => {
    //  const config = await http.getWithAwait("/config", false, true, () => {});

    const referrer = document ? document.referrer : window.document.referrer;
    let queryString = window.location.search.replace(/%27/g, "%22");
    let searchParams = new URLSearchParams(queryString);
    let whitlist = {
      cookie_consent: ["necessary", "preferences", "statistics", "marketing", "region", "utc", "ver"],
      search_params: [
        "student",
        "utm_id",
        "utm_campaign",
        "utm_source",
        "utm_medium",
        "utm_content",
        "utm_term",
        "g_client_id",
      ],
    };
    let newcookieconsent: { [key: string]: any } = {
      marketing: false,
      necessary: false,
      preferences: false,
      statistics: false,
    };
    let searchParamsObj: { [key: string]: any } = {};
    for (const [key, value] of searchParams.entries()) {
      if (key == "cookie_consent") {
        try {
          let val = decodeURIComponent(value.replace(/%27/g, "%22"));
          val = val.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
          let obj = JSON.parse(val);
          for (const [cookieconsentKey, cookieconsentValue] of Object.entries(obj)) {
            if (whitlist.cookie_consent.includes(cookieconsentKey)) {
              newcookieconsent[cookieconsentKey] = cookieconsentValue;
            }
          }
          searchParams.set(key, encodeURIComponent(JSON.stringify(newcookieconsent)));
        } catch (e) {
          console.log("Error parsing cookie_consent: ", e);
          searchParams.delete(key);
        }
      } else {
        if (whitlist.search_params.includes(key)) {
          searchParams.set(key, encodeURIComponent(value));
        } else {
          searchParams.delete(key);
        }
      }
    }

    /*
    const referrerEncoded = Buffer.from(referrer)
      .toString("base64")
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
      */
    const referrerEncoded = toBase64Url(referrer || "");
    let searchParamsAsString = [...searchParams.entries()].map(([key, value]) => `${key}=${value}`).join("&");
    searchParamsAsString = searchParamsAsString.replace("trial=true&", "");
    // Replacing & and = with + and ~ to bypass authParams regex
    // Filtering out cookie_consent since otherwise the string will be too long
    let searchParamsForAuthParams = [...searchParams]
      .filter(([key]) => !key.startsWith("cookie_consent"))
      .map(([key, value]) => `${key}~${value}`)
      .join("+");
    searchParamsAsString = searchParamsAsString.replace("trial~true+", "");
    const cookiesConsentParam = searchParams.get("cookie_consent") || null;

    const cookiesConsentObject = newcookieconsent;

    const cookiesConsentAsString = Object.entries(cookiesConsentObject)
      .map(([key, value]) => `${key}~${value}`)
      .join("+");

    let params = {
      appState: {
        referrer: referrer,
        targetUrl: window.location.pathname + "?" + searchParamsAsString,
      },
      authorizationParams: {
        audience: config.REACT_APP_AUTH_AUDIANCE,
        scope: "read:appointments openid profile email",

        "ext-trial": trialTag || "missing",
        "ext-student": false,
        "ext-referrer": referrerEncoded || "none",
        "ext-search-params": searchParamsForAuthParams || "none",
        "ext-cookies-consent": cookiesConsentAsString || "none",
        redirect_uri: `${window.location.origin}`,
      },
    };
    if (hint) {
      (params as any).authorizationParams["screen_hint"] = "signup";
    }
    if (loginWithRedirect1) {
      loginWithRedirect1(params);
    }
  };
  const toBase64Url = (value: string): string => {
    const bytes = new TextEncoder().encode(value);
    let binary = "";
    for (const b of bytes) binary += String.fromCharCode(b);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  };

  const TrialVersionButton = (props: {
    hint: boolean;
    config: any;
    loginWithRedirect: any;
    trialTag?: string;
  }): JSX.Element => {
    return (
      <span>
        <Button
          className="primary-btn login-btn trial-btn"
          onClick={() => RedirectForTrial(props.hint, props.config, props.loginWithRedirect, props.trialTag)}
        >
          {t("start_free_trial_.label")}
        </Button>
      </span>
    );
  };

  return [RedirectForTrial, TrialVersionButton];
}
